import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { HeaderComponent } from './components/header/header.component';
import { LeftNavigationComponent } from './components/left-navigation/left-navigation.component';
import { PageContentComponent } from './components/page-content/page-content.component';
import { PrevNextNavigationComponent } from './components/prev-next-navigation/prev-next-navigation.component';
import { RightNavigationComponent } from './components/right-navigation/right-navigation.component';
import { SearchModalComponent } from './components/search-modal/search-modal.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslationInitService } from './services/translation-init.service';
import { ImageModalComponent } from './components/image-modal/image-modal.component';
import { ZoomableImageDirective } from './directives/zoomable-image.directive';
import * as Sentry from '@sentry/angular';

// Factory function for TranslateHttpLoader
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '/common.json');
}

// Factory function for initializing translations
export function initializeTranslations(translationService: TranslationInitService) {
  return () => translationService.initTranslations();
}

@NgModule({
  declarations: [
    AppComponent,
    BreadcrumbComponent,
    HeaderComponent,
    LeftNavigationComponent,
    PageContentComponent,
    PrevNextNavigationComponent,
    RightNavigationComponent,
    SearchModalComponent,
    ImageModalComponent,
    ZoomableImageDirective,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    RouterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      defaultLanguage: 'en'
    })
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslations,
      deps: [TranslationInitService],
      multi: true
    },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
    { provide: APP_INITIALIZER, useFactory: () => () => {}, deps: [Sentry.TraceService], multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
